let anchorLinks = document.querySelectorAll("a[href^=https]");

for (var i = 0; i < anchorLinks.length; i++) {
   var a = anchorLinks[i];
   if(a.hostname != location.hostname) {
           a.rel = 'noopener';
           a.target = '_blank';
   }
}

let backToTop = document.querySelector("#back-to-top-link");

if (backToTop !== null) {
  window.addEventListener("scroll", function() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop >= 250 && backToTop.classList.contains('hidden')) {
      backToTop.classList.remove("hidden");
    } else if (scrollTop < 250 && !backToTop.classList.contains('hidden')) {
      backToTop.classList.add("hidden");
    }
  });

}

// Cart Redirect
const mainContentRedirect = document.getElementById('MainBodyContent');
const cartDrawerRedirectOpen = document.querySelector('cart-drawer');
const restrictedPageURL = '/cart';
const previousPageUrl = document.referrer;

function afterRedirect() {
    mainContentRedirect.classList.add('overflow-hidden');
    cartDrawerRedirectOpen.classList.add('active');
}

if (window.location.href.includes(restrictedPageURL)) {
    sessionStorage.setItem('afterRedirectAction', 'true');
    window.location.href = '/index?cart=1';
}

if (sessionStorage.getItem('afterRedirectAction') === 'true') {
    sessionStorage.removeItem('afterRedirectAction');
}

if (previousPageUrl.includes(restrictedPageURL)) {
    setTimeout(() => {
        afterRedirect();
    }, 500);
}

if (document.querySelector(".password.password-homepage-based")) {
  console.log("Homepage based password page");
  let path = window.location.href.split('?')[0];
  if (path.includes("/products/") || path.includes("/collections/") || path.includes("/pages/") || path.includes("account") || path.includes("/products/")) {
    window.location.href = window.location.origin;
  }
} else {
  console.log("Non homepage based password page");
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
      var event = new Event('load', { 'bubbles': true });
        this.countryEl.dispatchEvent(event);
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.querySelector("summary");
    this.elementToFocus = null;

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector, sort-by button), .mobile-facets__close').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );

    this.querySelectorAll('.mobile-facets__close').forEach((button) =>
      button.addEventListener('keyup', this.onKeyUp.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.target.classList.contains("mobile-facets__close") && event.code.toUpperCase() == 'ENTER') {
      this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
      return;
    }
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    event.stopPropagation();
    let summaryElement = event.target;
    if (event.target.classList.contains("header__icon--menu")) {
      event.target.setAttribute("element-to-focus", "true");
      this.elementToFocus = event.target;
      summaryElement = this.summary;
    } else {
      this.elementToFocus = null;
      
    }
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }
    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 1024px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.detailsElement = this.querySelector("details");
    this.drawerButtons = document.querySelectorAll('.section-header .header__icon--menu.header__icon--summary');
    this.drawerCloseButton = this.querySelector('.menu-drawer-close-button');
    this.drawerNonBlock = this.querySelectorAll('.multi-tier-drawer__parent');
    this.elementToFocus = null;
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') {
        this.drawerCloseButton.click();
      }
    });
    this.drawerButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (button.getAttribute('aria-expanded') == 'true') {
          if(this.drawerCloseButton){
           this.drawerCloseButton.click();
          }
        }
      });
    });
    if(this.drawerNonBlock){
      this.drawerNonBlock.forEach((item) => {
        this.drawerNonBlockLink = item.querySelector('.multi-tier-drawer__parent-link');
        this.drawerNonBlockDetails = item.querySelector('.main-link-details');
        if (this.drawerNonBlockLink){
          if (item.contains(this.drawerNonBlockDetails)) {
            this.drawerNonBlockLink.remove();
          }
        }
      });
    }
  }

  onFocusOut() {
    event.preventDefault();
    setTimeout(() => {
      this.elementToFocus = document.querySelector("[element-to-focus='true']");
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) {}
    });
  }

  openMenuDrawer(summaryElement) {
    this.elementToFocus = event.target;
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');
    this.drawerButtons.forEach((button) => {
      button.setAttribute("aria-expanded", true);
    });
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    this.detailsElement.setAttribute("open", "");

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus || elementToFocus === null) return;
    if (this.drawerCloseButton == null) {
      super.closeMenuDrawer(event, elementToFocus);
      this.header.classList.remove('menu-open');
      this.detailsElement.removeAttribute('open');
      this.detailsElement.classList.remove('menu-opening');
      this.drawerButtons.forEach((button) => {
        button.setAttribute("aria-expanded", false);
      });
    }
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden-modal');
    document.getElementsByTagName('html')[0].classList.add('overflow-hidden-modal');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden-modal');
    document.getElementsByTagName('html')[0].classList.remove('overflow-hidden-modal');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      if (button.classList.contains("quick-add__submit-bypass")) {
        window.location.href = button.dataset.productUrl;
      } else {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
      }
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.sliderType = this.dataset.sliderType;
    this.desktopPeek = this.dataset.desktopPeek;
    this.mobilePeek = this.dataset.mobilePeek;
    this.isSlider = this.dataset.isSlider;
    this.isQuickview = this.dataset.isSlider;
    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => {
      this.initPages();
      if (this.sliderType == 'featured-collection' || this.sliderType == 'content-carousel') {
        this.adjustArrows();
      }
  });
    resizeObserver.observe(this.slider);

    if (this.sliderType == 'featured-collection') {
      if (window.matchMedia("(min-width: 768px)").matches) {
        this.sliderItems.forEach((slide) => {
          slide.classList.remove("zero-opacity");
        });
      } else {

      }
    const options = {
      threshold: 0.5,
    };
    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        /* Desktop */
        if (window.matchMedia("(min-width: 768px)").matches) {
          if (this.desktopPeek) {
            entry.target.classList.remove("zero-opacity");
          } else {
            if (entry.isIntersecting) {
              entry.target.classList.remove("zero-opacity");
            } else {
              entry.target.classList.add("zero-opacity");
            }
          }

        /* Mobile */
        } else {
          if (this.mobilePeek) {
            entry.target.classList.remove("zero-opacity");
          } else {
            if (entry.isIntersecting) {
              entry.target.classList.remove("zero-opacity");
            } else {
              entry.target.classList.add("zero-opacity");
            }
          }
        }
        
      });
        
    };

    const intersectionObserver = new IntersectionObserver(callback, options);
    this.sliderItems.forEach((item) => {
      intersectionObserver.observe(item);
    });
  }


    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    
    
  }

  connectedCallback() {
    if (this.sliderType == 'featured-collection' || this.sliderType == 'content-carousel') {
    this.adjustArrows();
    this.showArrows();
    }

  }

  adjustArrows() {
    if (this.prevButton && this.nextButton) {
      if (this.sliderType == 'featured-collection') {
        var firstElement = this.querySelector(".product-grid li");
      } else {
        var firstElement = this.querySelector(".slider__slide");
      }
    const cardImageContainer = firstElement.querySelector(".card__inner");
    let cardImageHeight = cardImageContainer.offsetHeight;
    let topOffset = Math.ceil((cardImageHeight / 2)) + 'px';
    if (this.sliderType == 'content-carousel') {
      let buttonHeight = this.prevButton.getBoundingClientRect().height;
      topOffset = Math.round((cardImageHeight / 2) - (buttonHeight / 2)) + 'px';
    }
    this.prevButton.style.top = topOffset;
    this.nextButton.style.top = topOffset;
    }
  }

  showArrows() {
    if (this.prevButton && this.nextButton) {
    this.prevButton.classList.remove("hidden");
    this.nextButton.classList.remove("hidden");
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      
      if (this.isSlider && this.isQuickview) {
        this.totalPages = this.sliderItemsToShow.length;
      }
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;


    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1], 0, "next")) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0, button) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    if (this.isSlider && button === 'next') {
      const scrollPosition = Math.ceil((this.slider.scrollLeft + this.sliderItemsToShow[this.sliderItemsToShow.length - 1].clientWidth));
      const scrollRight = this.sliderItemsToShow[this.sliderItemsToShow.length - 1].clientWidth * (this.sliderItemsToShow.length);
      return scrollPosition >= scrollRight;
    } else {
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    if (this.getAttribute('data-banner-height')) {
      this.sliderBannerHeight = this.dataset.bannerHeight;
    }

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }


    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();

    this.debouncedHandleAdaptableControls = debounce((event) => {
      this.handleAdaptableControls(event);
    }, 150);

    this.debouncedHandleAdaptableControls();

    window.addEventListener("resize", this.debouncedHandleAdaptableControls.bind(this));

  }

  connectedCallback() {
    this.videos = this.querySelectorAll("video");
    if (this.sliderItems.length == 1) {
      const resizeObserver = new ResizeObserver(debounce(throttle((entries) => {
        this.handleVideos();
      }), 300), 50);
      resizeObserver.observe(this.slider);
    }

    this.mutationObserver = new MutationObserver(debounce(throttle((mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "attributes" && mutation.attributeName === "aria-hidden" && mutation.target.getAttribute("aria-hidden") === 'true') {
          mutation.target.classList.add("visibility-hidden");
        }
      }
    }), 300), 50);

    this.debouncedHandleInit = debounce((event) => {
      throttle(this.handleInit(), 50);
    }, 250);

    this.debouncedOnTouchStart = debounce((event) => {
      this.onTouchStart();
    }, 250);

    this.debouncedHandleVideoControl = debounce((event) => {
      this.handleVideoControl(event);
    }, 150);

    this.addEventListener("initPages", this.debouncedHandleInit.bind(this));
    this.addEventListener("touchstart", this.debouncedOnTouchStart.bind(this), { passive: true});
    this.querySelectorAll(".slideshow__video-controls-play, .slideshow__video-controls-pause").forEach((element) => {
      element.addEventListener("click", this.debouncedHandleVideoControl.bind(this));
    });
  }

  handleAdaptableControls() {
    if (this.sliderBannerHeight == 'adapt' && this.getAttribute("data-mobile-bottom") == "true") {
      if (window.matchMedia("(min-width: 540px)").matches) {
        if (this.prevButton.hasAttribute("style") || this.nextButton.hasAttribute("style")) {
        this.prevButton.removeAttribute("style");
        this.nextButton.removeAttribute("style");
        if (this.querySelector(".slider-buttons.slider-dots-position--overlay")) {
        this.querySelector(".slider-buttons.slider-dots-position--overlay").removeAttribute("style");
        }
        }
      } else {
      this.sliderFirstItemMedia = this.sliderFirstItemNode.querySelector(".slideshow__media-picture");
      let firstItemMediaHeight = (this.sliderFirstItemMedia.offsetHeight / 10.0); //height in REM
      let firstItemArrowPosition = ((firstItemMediaHeight / 2) - ((window.controlSizes.arrowSizeMobile / 2.0) / 10)).toFixed(1) + 'rem';
      let firstItemDotsPosition = ((firstItemMediaHeight) - 3).toFixed(1) + 'rem';
      this.prevButton.style.setProperty('--top', firstItemArrowPosition);
      this.nextButton.style.setProperty('--top', firstItemArrowPosition);
      if (this.querySelector(".slider-buttons.slider-dots-position--overlay")) {
        this.querySelector(".slider-buttons.slider-dots-position--overlay").style.setProperty("top", firstItemDotsPosition);
      }
    }
  }
  }

  initPages() {
    super.initPages();
    this.dispatchEvent(new CustomEvent('initPages'));
  }

  handleInit() {
    this.handleVideos();
    this.sliderItems.forEach((slide) => {
      this.mutationObserver.observe((slide), {attributes: true});
    });

  }

  onTouchStart() {
    let hiddenSlides = this.querySelectorAll(".visibility-hidden");
    if (hiddenSlides.length > 0) {
      hiddenSlides.forEach((slide) => {
        slide.classList.remove("visibility-hidden");
      });
    }
  }



  handleVideoControl(event) {
    let targetVideo = event.target.closest(".media").querySelector("video");
    if (event.target.classList.contains("slideshow__video-controls-play") && targetVideo.paused) {
      targetVideo.play();
    } else if (event.target.classList.contains("slideshow__video-controls-pause") && !targetVideo.paused) {
      targetVideo.pause();
    }
  }

  handleVideos() {
    if (this.videos.length > 0) {
      this.videos.forEach((video) => {
        let slideContainer = video.closest(".slideshow__slide");
        let videoSources = video.dataset.srcs.split(",");
        let videoSourceElement = video.querySelector("source");
        let sameSource = true;
        if (window.matchMedia("(min-width: 768px)").matches) {
          if (videoSourceElement.getAttribute("src") != videoSources[1]) {
            videoSourceElement.setAttribute("src", videoSources[1]);
            sameSource = false;
          }
        } else {
          if (videoSourceElement.getAttribute("src") != videoSources[0]) {
            videoSourceElement.setAttribute("src", videoSources[0]);
            sameSource = false;
          }
        }
        if ((slideContainer.getAttribute("aria-hidden") === 'false' || this.sliderItems.length == 1) && !sameSource) {
          throttle(this.loadVideo(video), 100);
        }
      });
      
    }
  }

  loadVideo(video) {
    
    video.load();
    video.setAttribute("autoplay", true);
    video.play();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;
    let hiddenSlides = this.querySelectorAll(".visibility-hidden");
    if (hiddenSlides.length > 0) {
      hiddenSlides.forEach((slide) => {
        slide.classList.remove("visibility-hidden");
      });
    }
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout (() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    if (typeof this.sliderControlButtons[this.currentPage - 1] !== 'undefined') {
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }

  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    let hiddenSlides = this.querySelectorAll(".visibility-hidden");
    if (hiddenSlides.length > 0) {
      hiddenSlides.forEach((slide) => {
        slide.classList.remove("visibility-hidden");
      });
    }
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.stickyATCActive = document.querySelector('.sticky-atc');
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantLabels();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      window.postMessage(
        {
          type:"variant_changed",
          variant:this.currentVariant
        },"*");
    }

    this.announceButtonState();
    
  }

  announceButtonState() {
    const announcer = this.closest('[data-section-id], [data-section-type], product-info, .product')
      ?.querySelector('#product-availability-live');
    if (!announcer) return;

    const productTitle = this.closest('[data-section-id], [data-section-type], product-info, .product')
      ?.querySelector('.product__title h1')?.innerText.trim() || 'Product';

    const btn = document.querySelector(`#ProductSubmitButton-${this.dataset.section}`);
    if (!btn) return;

    const buttonText = (btn.querySelector('.product-form__submit-text')?.textContent || btn.innerText || '').toLowerCase();
    const isDisabled = btn.getAttribute('aria-disabled') === 'true' || btn.disabled;

    let newStatusText = '';

    if (buttonText.includes('coming soon') || btn.dataset.productLabel === 'coming soon') {
      newStatusText = `${productTitle} — Coming Soon - this item is not yet available for purchase`;
    } else if (isDisabled) {
      if (buttonText.includes('sold out')) {
        newStatusText = `${productTitle} — Sold Out`;
      } else {
        newStatusText = `${productTitle} — Unavailable`;
      }
    } else {
      newStatusText = `${productTitle} — selection registered, available to add to cart`;
    }

    if (announcer.textContent !== newStatusText) {
      announcer.textContent = '';
      setTimeout(() => {
        announcer.textContent = newStatusText;
      }, 100);
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantLabels() {
    const variantInputs = this.querySelectorAll("input:checked");
    variantInputs.forEach((input) => {
      let selector = input.parentElement.parentElement;
      if (selector.classList.contains("variant-radios")) {
        selector = input.parentElement;
      }
      let label = selector.querySelector(".product-option-value");
      if (label) {
        label.textContent = input.value;
      } else {
        return;
      }
    });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input, .product-variant-dropdown-set')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');

        if (this.stickyATCActive){
          const stickyPrice = document.querySelectorAll('.sticky-atc__price');
          stickyPrice.forEach(function(event){
            if (source && event){
                const originalStickyPriceId = event.firstElementChild.id;
                event.innerHTML = "<div class='no-js-hidden' role='status' id='" + originalStickyPriceId +"'>" + source.innerHTML + "</div>";
                event.classList.toggle('visibility-hidden', source.classList.contains('visibility-hidden'));
            }
          });
        }

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        let buttonVariantString = window.variantStrings.soldOut;
        
        const productFormEl = document.getElementById(`product-form-${this.dataset.section}`);
        const isProductComingSoon = productFormEl && productFormEl.closest('product-form')?.getAttribute('data-coming-soon') === 'true';

        if ((addButtonUpdated && addButtonUpdated.dataset.productLabel == 'coming soon') || isProductComingSoon) {
          buttonVariantString = window.variantStrings.comingSoon || 'Coming Soon';
        }

        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          buttonVariantString
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span.product-form__submit-text');
    const addButtonPrice = productForm.querySelector('[name="add"] > span.product-total__price');
    const stickyAddButton = document.querySelector('.sticky-product__button');
    const stickyAddButtonText = document.querySelector('.sticky-product__button .sticky-atc__text');
    const stickyBelowPercentageText = document.querySelector('.sticky-product-below__price');
    if (!addButton) return;

    if (addButtonPrice) {
      let addButtonPriceElement = addButtonPrice.querySelector(".price");
      const priceElement = document.getElementById(`price-${this.dataset.section}`);
      if (priceElement) {
        let originalPriceElement = priceElement.querySelector(".price");
        let updatedPriceElement = originalPriceElement.cloneNode(true);
        let updatedPriceBadges = updatedPriceElement.querySelector(".badge");
        if (updatedPriceBadges) {
          updatedPriceElement.classList.remove("price--show-badge");
          updatedPriceElement.querySelector(".badge").remove();
        }
        addButtonPriceElement.replaceWith(updatedPriceElement);
      }
    }

    if (disable) {
      addButton.setAttribute('disabled', 'disabled'); 
      if (text) addButtonText.textContent = text;
      if (stickyAddButton) {
        stickyAddButton.setAttribute('disabled', 'disabled');
      }
      if (text) {
        if (stickyAddButtonText) stickyAddButtonText.textContent = text;
      }
      if (stickyBelowPercentageText){
        stickyBelowPercentageText.classList.add('hidden');
      }
    } else {
      addButton.removeAttribute('disabled');
      if (stickyAddButton) {
        stickyAddButton.removeAttribute('disabled');
      }
      let buttonVariantString = window.variantStrings.addToCart;
      if (addButton.dataset.productLabel == 'preorder') {
        buttonVariantString = window.variantStrings.preOrder;
      } else if (stickyAddButton && stickyAddButton.dataset.productLabel == 'preorder') {
        buttonVariantString = window.variantStrings.preOrder;
      }
      if (stickyBelowPercentageText){
        stickyBelowPercentageText.classList.remove('hidden');
      }
      addButtonText.textContent = buttonVariantString;
      if (stickyAddButtonText){
      stickyAddButtonText.textContent = buttonVariantString;
      }
    }

    if (!modifyClass) return;
    }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span.product-form__submit-text');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class ProductVariantDropdown extends VariantRadios {
  constructor() {
    super();
    this.dropdownButton = this.querySelector("button.product-variant-dropdown-button");
    this.dropdownLabel = this.querySelector(".product-variant-dropdown-label");
    this.dropdownValue = this.querySelector(".product-variant-dropdown-value");
    this.dropdownContainer = this.querySelector(".dropdown");
    this.dropdownItems = this.querySelectorAll(".dropdown-item");
    this.dropdownInputs = this.querySelectorAll("input");
    this.variantData = JSON.parse(this.parentElement.querySelector('[type="application/json"]').textContent);
    this.elements = {
      button: this.querySelector("button.product-variant-dropdown-button"),
      panel: this.querySelector('.disclosure__list-wrapper'),
      list: this.querySelector('.disclosure__list'),
      links: this.querySelectorAll(".disclosure__link")
    };

    this.dropdownButton.addEventListener('click', this.openSelector.bind(this));
    this.addEventListener('focusout', this.closeSelector.bind(this));
    this.elements.links.forEach((link) => {
      link.addEventListener('click', (event) => {
        const input = link.parentNode.querySelector('input');
        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    this.dropdownInputs.forEach((input) => input.addEventListener('change', this.onVariantInputChange.bind(this)));
    this.elements.list.addEventListener('keydown', this.onVariantInputKeydown.bind(this));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  openSelector(event) {
    event.preventDefault();
    const isExpanded = this.elements.button.getAttribute('aria-expanded') === 'true';
    if (isExpanded) {
      this.hidePanel();
    } else {
      this.elements.button.setAttribute('aria-expanded', 'true');
      this.elements.panel.removeAttribute('hidden');
      this.elements.button.focus();
    }
  }

  closeSelector(event) {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.hidePanel();
      }
    }, 150);
  }

  onVariantInputChange(event) {
    let newActiveValue = event.target.value;
    if (this.dropdownValue) {
      this.dropdownValue.textContent = newActiveValue;
    }
    this.elements.links.forEach((link) => {
      if (link.previousElementSibling === event.target || link.parentNode.querySelector('input') === event.target) {
        link.classList.add("disclosure__link--active");
      } else {
        link.classList.remove("disclosure__link--active");
      }
    });
    this.hidePanel();
  }

  onVariantInputKeydown(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      event.target.checked = true;
      event.target.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (event.keyCode === 38 || event.keyCode === 40) {
      event.preventDefault();
      if (event.keyCode === 38) {
        if (event.target.parentNode.previousElementSibling) {
          event.target.parentNode.previousElementSibling.querySelector('input')?.focus();
        }
      } else {
        if (event.target.parentNode.nextElementSibling) {
          event.target.parentNode.nextElementSibling.querySelector('input')?.focus();
        }
      }
    }
  }
}

customElements.define('product-variant-dropdown', ProductVariantDropdown);

/* Footer */
class FooterDropdown extends HTMLElement {
  constructor() {
    super();
    this.heading = this.querySelector(".footer-block__heading.uses-dropdown");
    
    this.contentBlock = this.querySelector(".footer-block__details-content");
    if (this.heading !== null) {
      this.heading.addEventListener('click', this.handleDropdown.bind(this));
      this.headingIconContainer = this.heading.querySelector(".footer-block__heading-icon");
      this.mobileIcons = this.heading.querySelectorAll("svg");
    }
    
  }

  connectedCallback() {
    if (this.contentBlock !== null && this.mobileIcons !== null && typeof this.headingIconContainer !== 'undefined') {
      if (this.contentBlock.dataset.open === 'true') {
        this.headingIconContainer.dataset.open = 'true';
      } else {
        this.headingIconContainer.dataset.open = 'false';
      }
    }
    
  }

  handleDropdown(event) {
    let header = event.target;
    let iconContainer = header.querySelector(".footer-block__heading-icon");
    let dropdown = header.nextElementSibling;
    if (dropdown.dataset.open === 'true') {
      dropdown.dataset.open = 'false';
      iconContainer.dataset.open = 'false';
    } else {
      dropdown.dataset.open = 'true';
      iconContainer.dataset.open = 'true';
    }
  }
}

customElements.define('footer-dropdown', FooterDropdown);

/* ADA Compliant Disabled Buttons */  
(function() {
  const BUTTON_SELECTOR = 'button.product-form__submit, input.product-form__submit[type="submit"]';
  const DISABLED_TEXT_TRACKERS = ['sold out', 'coming soon', 'unavailable'];

  function shouldBeDisabled(button) {
    if (button.hasAttribute('disabled')) return true;
    const buttonText = (button.tagName === 'INPUT' ? button.value : button.textContent).toLowerCase();
    return DISABLED_TEXT_TRACKERS.some(text => buttonText.includes(text));
  }
  
  function processButton(button) {
    if (button.dataset.processing) return;
    button.dataset.processing = 'true';

    const buttonsContainer = button.closest('.product-form__buttons');

    if (shouldBeDisabled(button)) {
      button.removeAttribute('disabled');
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('is-aria-disabled');
      
      if (buttonsContainer) {
        buttonsContainer.classList.add('sold-out');
      }
    } else {
      button.removeAttribute('aria-disabled');
      button.classList.remove('is-aria-disabled');
      
      if (buttonsContainer) {
        buttonsContainer.classList.remove('sold-out');
      }
    }

    delete button.dataset.processing;
  }

  function makeButtonsAccessible() {
    document.querySelectorAll(BUTTON_SELECTOR).forEach(processButton);
  }

  function handleDisabledInteractions(event) {
    const button = event.target.closest('.product-form__submit[aria-disabled="true"]');
    if (!button) return;

    if (event.type === 'click' || event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', makeButtonsAccessible);
  } else {
    makeButtonsAccessible();
  }
  
  document.addEventListener('click', handleDisabledInteractions, true);
  document.addEventListener('keydown', handleDisabledInteractions, true);

  const observer = new MutationObserver((mutations) => {
    let shouldCheck = false;

    for (const mutation of mutations) {
      if (mutation.target.dataset && mutation.target.dataset.processing) continue;

      if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
        if (mutation.target.matches(BUTTON_SELECTOR)) {
          processButton(mutation.target);
        }
      } else if (mutation.type === 'childList' || mutation.type === 'characterData') {
        shouldCheck = true;
      }
    }

    if (shouldCheck) {
      makeButtonsAccessible();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true,
    attributeFilter: ['disabled']
  });
})();

/* Promo Video Play/Pause */
function initCustomVideoBlocks() {
  const toggleButtons = document.querySelectorAll('[data-toggle-btn]');

  toggleButtons.forEach(button => {
    if (button.dataset.initialized) return;
    button.dataset.initialized = true;

    button.addEventListener('click', () => {
      const container = button.closest('[data-video-block]');
      if (!container) return;
      
      const video = container.querySelector('.promo-block-video');
      if (!video) return;

      if (video.paused) {
        video.play();
        button.classList.add('is-playing');
        button.setAttribute('aria-label', 'Pause Video');
      } else {
        video.pause();
        button.classList.remove('is-playing');
        button.setAttribute('aria-label', 'Play Video');
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCustomVideoBlocks);
} else {
  initCustomVideoBlocks();
}

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', initCustomVideoBlocks);
  document.addEventListener('shopify:block:select', initCustomVideoBlocks);
}
